import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { Avatar, CircularProgress, Box, Typography } from '@mui/material';
import { AddCircleOutlineOutlined } from '@mui/icons-material';
import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholderThumb from 'styles/assets/placeholder/placeholderThumbTriibo.webp';

const cloneOrgs = (items) => (Array.isArray(items) ? items.map((item) => ({ ...item })) : items);

const HomeTriibosCarousel = ({ userOrgs }) => {
  const [orgs, setOrgs] = React.useState(false);
  const { t } = useTranslation('app');

  useEffect(() => {
    setOrgs(cloneOrgs(userOrgs));
  }, [userOrgs]);

  function downloadImageOnLoad(i) {
    if (!Array.isArray(orgs) || !orgs[i]) return;

    if (orgs[i].downloaded === undefined) {
      const img = orgs[i].thumbnail.split('/');
      downloadImage(img[0], img[1])
        .then((downloadedImg) => {
          const array = [...orgs];
          array[i].downloaded = downloadedImg;
          setOrgs(array);
        })
        .catch((error) => error);
    }
  }

  return (
    <Box
      sx={{
        display: 'block',
        '@media (min-width: 900px)': { display: 'none' },
      }}
    >
      {orgs === false ? (
        <Box sx={{ mb: 2.5, py: 1, textAlign: 'center' }}>
          <CircularProgress />
        </Box>
      ) : orgs === null || orgs === undefined ? null : (
        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 2,
            px: 2,
            py: 1,
            scrollSnapType: 'x mandatory',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <Box
            sx={{
              flex: '0 0 auto',
              scrollSnapAlign: 'start',
              textAlign: 'center',
              width: 80,
            }}
          >
            <Link to="/addTriibos" style={{ textDecoration: 'none' }}>
              <Avatar sx={{ margin: '0 auto' }}>
                <AddCircleOutlineOutlined />
              </Avatar>
              <Typography
                variant="caption"
                sx={{
                  fontSize: 10,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color: '#000',
                  display: 'block',
                }}
              >
                {t('home.suggested')}
              </Typography>
            </Link>
          </Box>

          {orgs.map((triibo, i) => (
            <Box
              key={triibo.orgID}
              sx={{
                flex: '0 0 auto',
                scrollSnapAlign: 'start',
                textAlign: 'center',
                width: 80,
              }}
            >
              <Link
                to={{
                  pathname: '/triibos/',
                  search: '?id=' + triibo.orgID,
                  state: triibo,
                }}
                style={{ textDecoration: 'none' }}
              >
                <Avatar sx={{ margin: '0 auto' }}>
                  <img
                    src={triibo.downloaded ?? placeholderThumb}
                    width="100%"
                    alt="thumb"
                    onLoad={() => downloadImageOnLoad(i)}
                  />
                </Avatar>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 10,
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#000',
                    display: 'block',
                  }}
                >
                  {triibo.name}
                </Typography>
              </Link>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default HomeTriibosCarousel;
